/** RevenueCat entitlement that unlocks DoughBro Pro. */
export const DOUGHBRO_PRO_ENTITLEMENT = "DoughBro Pro";

/** Current offering lookup key in the RevenueCat dashboard. */
export const DOUGHBRO_DEFAULT_OFFERING = "default";

/** Store product identifier for the $1.99/month Pro plan. */
export const DOUGHBRO_MONTHLY_PRODUCT_ID = "doughbro_pro_monthly";
